export function Round(val: number, decimals: number) {
    let decimalCount = '2';
    if (decimals && !isNaN(decimals)) {
        decimalCount = decimals.toString();
    }

    // https://www.jacklmoore.com/notes/rounding-in-javascript/
    return Number(Math.round(Number(val + 'e' + decimals)) + 'e-' + decimals);
}

export function ToCurrency(val: number) {
    return Round(val, 2).toFixed(2);
}

export function ToPayPal(val: number) {
    var val = Math.ceil(val * 100) / 100;
    return val.toFixed(2);
};